import React from 'react'

import { useScreenSizeHook } from './useScreenSizeHook'

type TScreenSizeContext = {
  status: string
  isDesktop: boolean
  toggleDesktop: boolean
}

export const ScreenSizeContextDefaultValue: TScreenSizeContext = {
  status: 'loading',
  isDesktop: false,
  toggleDesktop: false,
}

export const ScreenSizeContext = React.createContext(
  ScreenSizeContextDefaultValue
)

ScreenSizeContext.displayName = 'ScreenSizeContext'

export function useScreenSizeContext() {
  const context = React.useContext(ScreenSizeContext)
  if (context === undefined) {
    throw new Error(
      'ScreenSizeContext must be used within a ScreenSizeContext.Provider'
    )
  }
  return context
}

export function WithScreenSizeContext(props: any) {
  const screenSize = useScreenSizeHook()

  return <ScreenSizeContext.Provider value={screenSize} {...props} />
}
